var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "cancelCampaign",
    attrs: {
      "modal-dialog-size": "xs",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("campaigns.actions.noKeepCampaign"),
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("global.words.confirmation")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("campaigns.messages.confirmCancelCampaign.0"))
            ),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.$t("campaigns.messages.confirmCancelCampaign.1"))
              ),
            ]),
            _vm._v(
              _vm._s(_vm.$t("campaigns.messages.confirmCancelCampaign.2")) +
                "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: { disabled: _vm.isPastDate, loading: _vm.canceling },
                on: { click: _vm.handleSubmit, finish: _vm.closeModal },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("campaigns.actions.yesCancelCampaign")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }